@if (svgIconUrl) {
  <lib-svg-icon [url]="svgIconUrl" [size]="size" (loadFailed)="loadFailed()"></lib-svg-icon>
} @else {
  <i
    class="icon ph ph-{{icon}}"
    [class.ph-bold]="bold"
    [class.ph-duotone]="duotone"
    [class.ph-fill]="fill"
    [style.fontSize.px]="size">
  </i>
}

